import React from 'react';

import SignInBox from './app/sign-in';
import { Typography, Box } from '@mui/material';

const AppUnauthed = () => {
    return (<React.Fragment>
        <div style={ { width: 400, height: 200, margin: 'auto' } }>
            <Typography variant="body1" align="center" sx={{ marginBottom: 2 }}>
                Crate and Tools Service Portal
            </Typography>
            <SignInBox />
        </div>
    </React.Fragment>)
}

export default AppUnauthed;
